import React from "react";
import { NavLink } from "react-router-dom";
import { FaGasPump, FaCar, FaUsers, FaCalendarAlt, FaTag, FaSuitcase } from "react-icons/fa";
import "./CarCard.css";

const CarCard = ({ car }) => {
  return (
    <div className="car-card">
      <div className="car-image-container">
        <img 
          src={car.image} 
          alt={`Véhicule ${car.name}`} 
          className="car-image" 
          loading="lazy"
        />
        {car.available ? (
          <span className="availability-tag available">DISPO</span>
        ) : (
          <span className="availability-tag unavailable">NON DISPO</span>
        )}
      </div>
      
      <div className="car-name-container">
        <h3>{car.name}</h3>
      </div>
      
      <div className="car-price-container">
        <p className="car-price"> <span className="price-period">à partir de </span>{car.price} {car.currency || "DA"}<span className="price-period"> / jour</span></p>
      </div>
      
      <div className="car-info">
        <div className="car-specs">
          <div className="spec-item">
            <FaCar />
            <span>{car.transmission}</span>
          </div>
          <div className="spec-item">
            <FaGasPump />
            <span>{car.fuel}</span>
          </div>
          <div className="spec-item">
            <FaUsers />
            <span>{car.passengers} places</span>
          </div>
          <div className="spec-item">
            <FaCalendarAlt />
            <span>{car.year}</span>
          </div>
          <div className="spec-item">
            <FaTag />
            <span>{car.category}</span>
          </div>
          {car.luggage && (
            <div className="spec-item">
              <FaSuitcase />
              <span>{car.luggage}</span>
            </div>
          )}
        </div>
        
        <div className="card-actions">
          <NavLink to={`/reservation?voitureId=${car.id}`} className="reservation-link">
            <button className="reservation-button" disabled={!car.available}>
              {car.available ? "Réserver" : "Indisponible"}
            </button>
          </NavLink>
          <NavLink to={`/voitures/${car.id}`} className="details-link">
            <button className="details-button">Détails</button>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default CarCard;
